import React, { useEffect, useState } from 'react';
import './Hero.css';
import logo from '../../assets/images/logo.svg';
import cta from '../../assets/images/CTA.png';
import losenge from '../../assets/images/losenge.png';
import liveNowAppStore from '../../assets/images/live_now_app_store.png';
import phones from '../../assets/images/phones.png';
import homeMobile from '../../assets/images/home-mobile.png';
import home from '../../assets/images/home.jpg';
import Clock from '../Clock/Clock';
import FadeInSection from '../FadeInSection/FadeInSection';

const Hero: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="hero-section">
      <div 
        className="hero-bg"
        style={{
          backgroundImage: `url(${isMobile ? homeMobile : home})`
        }}
      />
      <Clock />
      <div className="logo-container">
        <img src={logo} alt="Heal" className="logo" />
      </div>
      <a
        href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
        target="_blank"
        rel="noopener noreferrer"
        className="live-now-app-store"
        aria-label="HEAL is now Live on Apple iOS – open in App Store"
      >
        <img src={liveNowAppStore} alt="HEAL is now Live on Apple iOS" />
      </a>
      <FadeInSection>
        <img src={losenge} alt="" className="hero-lozenge" />
        <h1 className="hero-text">
          Music + Breathwork platform designed to regulate the nervous system 
        </h1>
      </FadeInSection>
      <FadeInSection delay={300}>
        <p className="hero-subtext">Reduce stress, improve sleep & longevity.</p>
      </FadeInSection>
      <FadeInSection delay={600}>
        <div className="cta-container">
          <a
            href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
            aria-label="Get Started on the App Store"
          >
            <img src={cta} alt="Get Started" />
          </a>
        </div>
      </FadeInSection>
      <div className="phones-container">
        <img
          src={phones}
          alt="Heal app on iPhone showing music therapy and breathwork"
          className="phones-image"
        />
      </div>
    </section>
  );
};

export default Hero; 